import { MySection } from '@/components/custom/my-section';
import { ProductFormValues, ProductUpdateValues } from '@/types/product-type';
import { FormControlLabel, Grid, Switch } from '@mui/material';
import { Control, Controller } from 'react-hook-form';

interface ProductSettingsProps {
  control: Control<ProductFormValues | ProductUpdateValues | any>;
  /** When true, renders only the Switch without the MySection card wrapper */
  inline?: boolean;
  fieldName?: 'isActive' | 'onStoreFront';
}

const switchSx = {
  '& .MuiSwitch-switchBase.Mui-checked': { color: '#2563EB' },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#2563EB' },
  '& .MuiSwitch-switchBase.Mui-checked:hover': { backgroundColor: 'rgba(37, 99, 235, 0.1)' },
  '& .MuiSwitch-track': { backgroundColor: '#9CA3AF' },
};

export function ProductSettingsFormSection({ control, inline, fieldName = 'isActive' }: ProductSettingsProps) {
  const toggle = (
    <Controller
      name={fieldName}
      control={control}
      render={({ field }) => (
        <Switch
          checked={!!field.value}
          onChange={(_, checked) => field.onChange(checked)}
          sx={switchSx}
        />
      )}
    />
  );

  if (inline) {
    return toggle;
  }

  return (
    <MySection title="Settings">
      <Grid container gap={2}>
        <Grid item xs={12}>
          <Controller
            name={'isActive'}
            control={control}
            render={({ field }) => (
              <FormControlLabel
                control={
                  <Switch
                    checked={!!field.value}
                    onChange={(_, checked) => field.onChange(checked)}
                    sx={switchSx}
                  />
                }
                label="Product is active"
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name={'onStoreFront'}
            control={control}
            render={({ field }) => (
              <FormControlLabel
                control={
                  <Switch
                    checked={!!field.value}
                    onChange={(_, checked) => field.onChange(checked)}
                    sx={switchSx}
                  />
                }
                label="Display on Telegram Mini App"
              />
            )}
          />
        </Grid>
      </Grid>
    </MySection>
  );
}
